/** FICZERY DO FeaturesBoxSimpleBlock */

/** STANDARDOWE */

export const STANDARD_APP_FEATURES: FeatureElementData[] = [
  {
    featureIconClassName: "document-add",
    featureName: "FAKTUROWANIE I CRM",
    featureText: "Wystawisz fakturę o każdej porze, Fakturomania posiada również integrację z KSeF i jest zawsze aktualizowana."
  },
  {
    featureIconClassName: "calculator",
    featureName: "KSIĘGOWOŚĆ ONLINE",
    featureText: "Dla mikro spółek - z o.o. oraz p.s.a., które bez trudu z nami poprowadzisz. Przekonaj się, że jest to możliwe i proste."
  },
  {
    featureIconClassName: "messages",
    featureName: "WSPARCIE KSIĘGOWE",
    featureText: "Nasi księgowi są do Twojej dyspozycji. Jeżeli masz pytania dotyczące księgowości lub spółek - skontaktuj się."
  },
  {
    featureIconClassName: "user-add",
    featureName: "KADRY",
    featureText: "Wyliczysz PIT i ZUS w łatwym, zintegrowanym i uproszczonym module kadrowym."
  },
  {
    featureIconClassName: "chart-bar",
    featureName: "ANALIZY FINANSOWE",
    featureText: "Dostępne pod ręką 24/7. Pełna księgowość to dokładne informacje na temat sytuacji gospodarczej twojej firmy."
  },
  {
    featureIconClassName: "download",
    featureName: "DEKLARACJE PODATKOWE",
    featureText: "Struktury podatkowe z łatwością wygenerujesz w Fakturomanii i przekażesz je do Ministerstwa Finansów."
  }
];

/** NASZ ZESPOL */

export const NASZ_ZESPOL_FEATURES: FeatureElementData[] = [
  {
    featureIconClassName: "folder",
    featureName: "KSIĘGOWOŚĆ",
    featureText: "Dysponujemy rozległą wiedzą specjalistyczną, jak również bardzo dużym doświadczeniem w zakresie księgowości."
  },
  {
    featureIconClassName: "calculator",
    featureName: "PODATKI",
    featureText: "Na bieżąco śledzimy zmiany dotyczące ustawodastwa w zakresie mogącym mieć wpływ na funkcjonowanie przedsiębiorstwa."
  },
  {
    featureIconClassName: "clipboard",
    featureName: "SPRAWY SPÓŁKOWE",
    featureText: "Doskonale wiemy, z jakimi problemami mierzą się firmy działające w formie spółki. Specjalizujemy się w ich rozwiązywaniu."
  }
];

/** PROGRAM DO FAKTUR */
export const FAKTURY_FEATURES: FeatureElementData[] = [
  {
    featureIconClassName: "document-add",
    featureName: "FAKTUROWANIE",
    featureText: "Wystawisz fakturę o każdej porze, w języku polskim oraz angielskim, w różnych walutach oraz szablonach."
  },
  {
    featureIconClassName: "calculator",
    featureName: "KSeF",
    featureText: "Fakturomania posiada integrację z KSeF i jest zawsze aktualizowana. Wymiana danych jest możliwa na kilka sposobów."
  },
  {
    featureIconClassName: "messages",
    featureName: "WSPARCIE SERWISU",
    featureText: "Nasi księgowi są do Twojej dyspozycji. Jeżeli masz pytania dotyczące sposobu wystawiania faktur - skontaktuj się."
  },
  {
    featureIconClassName: "mail",
    featureName: "WYSYŁKA",
    featureText: "W prosty sposób wyślesz fakturę do kontrahenta z indywidualną treścią, tak aby bezpiecznie ją otrzymał."
  },
  {
    featureIconClassName: "download",
    featureName: "DEKLARACJE PODATKOWE",
    featureText: "Struktury podatkowe, w tym JPK_FA z łatwością wygenerujesz i przekażesz do Ministerstwa Finansów."
  },
  {
    featureIconClassName: "chart-bar",
    featureName: "ANALIZY FINANSOWE",
    featureText: "Zbiorcze pobieranie faktur w różnych formatach - PDF, XML, tabelach XLSX czy CSV, które są dostępne pod ręką 24/7. "
  }
];

/** BACKGROUND_COLORS */

export const TRANSPARENT_BACKGROUND_COLOR: string = 'none';
export const GREY_BACKGROUND_COLOR: string = '#F3F5F7';


// WEBPACK FOOTER //
// ./src/constants/features-data.ts